import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FormGroup, InputGroup, Button, AnchorButton, HTMLTable } from "@blueprintjs/core";
import { AxiosInstance } from 'axios';

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import { SysInfo } from './Types'
import * as utils from "./utils";

// import {versionString, productName} from "./App"
declare var productName: string;

interface SysInfoProps {
    svc: AxiosInstance,
}

function SysInfoMain({ svc }: SysInfoProps) {
    const history = useHistory()
    const { t, i18n } = useTranslation();
    const [sysinfo, setSysInfo] = useState({} as SysInfo)
    const [changeReg, setChangeReg] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                const res = await svc.post('/sysinfo')
                console.log("sysinfo", res.data.data)
                //console.log("ac3web", versionString)
                setSysInfo(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [])

    return (
        <>
            <div style={{fontSize: "21px", fontWeight: 700}}>{productName}</div>
            <div className="Spacing-V-16"></div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('edition')}>
                    <InputGroup readOnly value={t(sysinfo.edition)} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('version')}>
                    <InputGroup readOnly value={sysinfo.versionString} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('port')}>
                    <InputGroup readOnly value={sysinfo.port?.toString()} />
                </FormGroup>
            </div>
            <div className="Spacing-V-16"></div>
            <h4>{t('access_text')}</h4>
            <HTMLTable striped interactive condensed>
                <thead>
                    <th className="TCol-Type">{t('ip')}</th>
                    <th className="TCol-URL">{t('url')}</th>
                </thead>
                <tbody>
                    {sysinfo.ips?.map((ip, i) =>
                        ip.ip !== "127.0.0.1" && <tr key={i}>
                            <td className="TCol-Type">{ip.ip}</td>
                            <td className="TCol-URL"><a href={`http://${ip.ip}:${sysinfo.port?.toString()}`}>http://{ip.ip}:{sysinfo.port?.toString()}</a></td>
                        </tr>
                    )}
                </tbody>
            </HTMLTable>
        </>
    );
}

export default SysInfoMain